import * as React from 'react'

import { clsx } from 'clsx'

import { Image } from '@buffer-mono/popcorn'
import type { ImageProps } from '@buffer-mono/popcorn'

import styles from './MediaThumbnail.module.css'

export const MediaThumbnail = React.forwardRef<HTMLImageElement, ImageProps>(
  ({ alt, className, ...props }, ref) => (
    <Image
      ref={ref}
      alt={alt ?? 'Media thumbnail'}
      className={clsx(styles.thumbnail, className)}
      {...props}
    />
  ),
)

MediaThumbnail.displayName = 'MediaThumbnail'
